/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

import { getClassPrefixMixins } from '../config-provider/config-receiver.js';
import mixins from '../utils/mixins.js';
import 'vue';
import 'lodash/mergeWith';
import '../config-provider/context.js';
import 'lodash/merge';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '@babel/runtime/helpers/typeof';
import '../_chunks/dep-fdafdce0.js';
import 'dayjs';
import '../_chunks/dep-9849f16c.js';
import '../config-provider/type.js';

var classPrefixMixins = getClassPrefixMixins("slider");
var TSliderMark = mixins(classPrefixMixins).extend({
  name: "TSliderMark",
  props: {
    mark: {
      type: [Object, Array, String]
    },
    point: {
      type: Number
    }
  },
  methods: {
    changeValue: function changeValue(event) {
      event.stopPropagation();
      this.$emit("change-value", this.point);
    }
  },
  render: function render() {
    var h = arguments[0];
    var label = this.mark;
    return h("div", {
      "class": "".concat(this.componentName, "__mark-text"),
      "on": {
        "click": this.changeValue
      }
    }, [label]);
  }
});

export { TSliderMark as default };
//# sourceMappingURL=slider-mark.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/slider/slider-mark.js
// module id = null
// module chunks = 